import { Anchor, AnchorGroup } from "@/components/anchors-navigation";
import FilterButton from "@/components/filtering/Button";
import UserComments from "@/components/UserComments";
import Downloads from "@/pages/user-pages/downloads";
import { PageType } from "@/services/shared-models/PageType";
import { Element, ROOT_NODE, useEditor, useNode } from "@craftjs/core";
import { useTranslation } from "react-i18next";
import DownloadsHeading from "./components/Heading";

const DownloadsContent = () => {
    const {
        connectors: { connect },
    } = useNode();

    const { enabled, comments } = useEditor((state) => ({
        enabled: state.options.enabled,
        comments: state.nodes[ROOT_NODE].data.props.comments === "yes",
    }));

    const { t } = useTranslation("common");

    return (
        <div ref={(ref) => connect(ref!)}>
            <main className="container relative mx-auto 2xl:px-[108px] z-1 pb-40">
                <div className="relative grid grid-cols-[auto_1fr] gap-13 gap-y-50 mt-36">
                    <AnchorGroup>
                        <FilterButton />
                        {comments && (
                            <Anchor id="block-comments" small>
                                {t("comments.title")}
                            </Anchor>
                        )}
                    </AnchorGroup>

                    {enabled ? (
                        <div className="relative w-full col-start-2 h-50 flex items-center text-center">
                            <span className="m-auto">Downloads will appear here</span>
                        </div>
                    ) : (
                        <Downloads />
                    )}

                    {comments && (
                        <section id="block-comments" className="col-start-2 mb-20">
                            {enabled ? (
                                <>
                                    <div className="flex items-center justify-between">
                                        <h2 className="font-bold text-[45px] text-primary-500">
                                            {t("comments.title")}
                                        </h2>
                                    </div>
                                    <div className="flex h-20 items-center italic">
                                        Comments will be displayed here on the live page.
                                    </div>
                                </>
                            ) : (
                                <UserComments pageType={PageType.Content} />
                            )}
                        </section>
                    )}
                </div>

                <div className="col-start-3 place-self-center">
                    <Element
                        id="heading-end"
                        is={DownloadsHeading}
                        text={`Découvrez comment <span class="text-primary-500">utiliser ces fichiers</span>`}
                    />
                </div>
                <div id="lead-start" className="col-span-2 w-px mx-auto items-center" />
            </main>
        </div>
    );
};

DownloadsContent.craft = {
    displayName: "Content",
    rules: {
        canDrag: () => false,
        canMoveOut: () => false,
    },
    custom: {
        canDelete: false,
    },
};

export default DownloadsContent;
